<div class="agents-container">
    <div class="agents-header">
        <div class="header-left">
            <img src="assets/images/icons/user_card_id.png" alt="users Icon" class="file-icon">
            <span class="header-title">
            <span class="title-text">Agents ( <span class="title-count">{{ totalCount }}</span> )</span>

            </span>
        </div>

        <div class="header-right">
            <button class="add-article-btn" (click)="addAgent()">
                <img src="assets/images/icons/user_plus.png" alt="user" class="add-icon">
                <span>Ajouter un agent</span>
            </button>
        </div>
    </div>

    <div class="search-filter-row">
        <div class="search-container">
            <div class="search-input-group">
                <img src="assets/images/icons/input_search.png" alt="Search" class="search-icon">
                <input type="text" class="search-input" placeholder="Rechercher des agents..." [(ngModel)]="searchTerm" (input)="onSearch()">
            </div>
        </div>

        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedAvailability" (change)="onFilterChange()">
                <option value="all">Tous(Disponibilité)</option>
                <option value="true">Disponible</option>
                <option value="false">Indisponible</option>
            </select>
        </div>
        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedVisibility" (change)="onFilterChange()">
                <option value="all">Tous(Visibilité)</option>
                <option value="true">Compte Activer</option>
                <option value="false">Compte Inactive</option>
            </select>
        </div>

        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedSort" (change)="onSortChange()">
                <option value="" disabled>Trier par</option>
                <option value="createdAt,desc">Date (plus récent)</option>
                <option value="createdAt,asc">Date (plus ancien)</option>
                <option value="firstName,asc">Nom (A-Z)</option>
                <option value="firstName,desc">Nom (Z-A)</option>
            </select>
        </div>

        <button class="filter-btn custom-select" (click)="toggleFilterPopup()">
            <img src="assets/images/icons/filter.png" alt="Filter" class="filter-icon">
            <span>Filtrer</span>
        </button>
    </div>
    @if(isLoading){
    <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Chargement des membres...</p>
    </div>} @if(!isLoading && agents.length === 0){
    <div class="empty-state">
        <p>Aucun membre trouvé</p>
    </div>}

    <!-- List -->
    @if(!isLoading && agents.length > 0){
    <div class="agents-grid">
        <app-admin-agent-card *ngFor="let agent of agents" [agent]="agent" (agentUpdated)="onAgentUpdated()" (agentDeleted)="onAgentDeleted()">
        </app-admin-agent-card>
        @if(totalPages>1){
        <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="onPageChange($event)"></app-pagination>
        }
    </div>}
</div>